import { Component, type ReactNode } from "react";
import { Button } from "@/components/ui/button";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4">
          <div className="text-center max-w-md">
            <p className="text-6xl font-bold text-accent mb-4">:(</p>
            <h1 className="text-2xl font-bold text-foreground mb-3">Algo deu errado</h1>
            <p className="text-muted-foreground mb-8 text-sm">
              Ocorreu um erro inesperado. Tente recarregar a página ou volte para a home.
            </p>
            <Button onClick={this.handleReset} className="bg-accent hover:bg-accent/90 text-white">
              Voltar para a Home
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
